// src/components/PieChartComponent.jsx
import React from "react";
import { Pie } from "react-chartjs-2";
import PropTypes from "prop-types";

const PieChartComponent = ({ data, options }) => {
  const hasData =
    data &&
    Array.isArray(data.datasets) &&
    data.datasets[0] &&
    Array.isArray(data.datasets[0].data) &&
    data.datasets[0].data.length > 0;

  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 8,
        right: 8,
        bottom: 8,
        left: 8,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          usePointStyle: true,
          padding: 16,
          font: {
            family: "'Vazirmatn', sans-serif",
            size: 11, // مشابه بقیه چارت‌ها
          },
          color: "#4B5563",
        },
      },
      title: {
        display: false, // عنوان در کارت است، نه داخل چارت
      },
      tooltip: {
        backgroundColor: "rgba(15, 23, 42, 0.9)",
        titleFont: {
          family: "'Vazirmatn', sans-serif",
          size: 13,
        },
        bodyFont: {
          family: "'Vazirmatn', sans-serif",
          size: 12,
        },
        padding: 10,
        cornerRadius: 8,
      },
    },
    animation: {
      duration: 900,
      easing: "easeOutQuad",
    },
  };

  const finalOptions = options || defaultOptions;

  return (
    <div className="relative w-full h-full min-h-[220px] sm:min-h-[260px] md:min-h-[280px]">
      <div className="absolute inset-0">
        {hasData ? (
          <Pie data={data} options={finalOptions} />
        ) : (
          <div className="flex items-center justify-center h-full text-sm text-slate-500">
            داده‌ای برای نمایش وجود ندارد.
          </div>
        )}
      </div>
    </div>
  );
};

PieChartComponent.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.arrayOf(
          PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        ),
      })
    ),
  }),
  options: PropTypes.object,
};

export default PieChartComponent;
